export const DroppableType = {
  FIELD: 'FIELD',
  SECTION: 'SECTION',
  PRIMARY_MEDICAL_HISTORY_OPTION: 'PRIMARY_MEDICAL_HISTORY_OPTION',
};

export const SEPARATOR = '__';
